<script>
	import TailwindCss from './TailwindCss.svelte'
	import VideoPlayer from './VideoPlayer.svelte'

	let pathname = window.location.pathname;
</script>
<TailwindCss/>

<main>
	<VideoPlayer {pathname}/>
</main>

<style>

</style>